import React, { useEffect, useState } from 'react';
import api from '../api/api';

interface Warehouse {
  id: number;
  name: string;
  code: string;
  isArchived: boolean;
}

interface InventoryWarehouseSelectProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  allLabel?: string;
  includeUnassigned?: boolean;
}

const InventoryWarehouseSelect: React.FC<InventoryWarehouseSelectProps> = ({
  value,
  onChange,
  label = 'Склад',
  required = true,
  disabled = false,
  allLabel,
  includeUnassigned = false,
}) => {
  const [warehouses, setWarehouses] = useState<Warehouse[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    api.get<Warehouse[]>('/operating-groups/warehouses')
      .then(response => {
        if (mounted) setWarehouses(response.data.filter(warehouse => !warehouse.isArchived));
      })
      .catch(() => {
        if (mounted) setError('Не вдалося завантажити список складів.');
      });
    return () => { mounted = false; };
  }, []);

  const options = [
    { key: 'all', value: '', label: allLabel ?? 'Оберіть склад' },
    ...(includeUnassigned
      ? [{ key: 'unassigned', value: 'unassigned', label: 'Історичні документи без складу' }]
      : []),
    ...warehouses.map(warehouse => ({
      key: String(warehouse.id),
      value: String(warehouse.id),
      label: `${warehouse.name} (${warehouse.code})`,
    })),
  ];

  return (
    <label>
      {label}
      <select
        required={required}
        disabled={disabled}
        value={value}
        onChange={event => onChange(event.target.value)}
        style={{ display: 'block', width: '100%', minHeight: 44, fontSize: 16 }}
      >
        {options.map(option => (
          <option key={option.key} value={option.value}>{option.label}</option>
        ))}
      </select>
      {error && <span role="alert">{error}</span>}
    </label>
  );
};

export default InventoryWarehouseSelect;
